import axios from "../../../../api/axios";
import { CommentsReportReasons } from "../types/commentsReportReasons.types";

export const getCommentsReportReasons = async (): Promise<CommentsReportReasons.ReportReason[]> => {
  const { data } = await axios.get("/lists/commentsReportReasons");
  return data.items;
};
